import { render } from "./CompareThree.vue?vue&type=template&id=98642ee4"
import script from "./CompareThree.vue?vue&type=script&lang=js"
export * from "./CompareThree.vue?vue&type=script&lang=js"

import "./CompareThree.vue?vue&type=style&index=0&id=98642ee4&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__